import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Container, Loader, Header, Dimmer, Segment, Grid} from 'semantic-ui-react';
import {compact, intersection} from 'lodash';
import {get} from './actions/itemsetGetAction';
import SetBonusTable from '../items/detail/summary-card/itemsets/SetBonusTable';
import PagedItemView from '../common/items/PagedItemView';
import SynergyCrystalBonusView from './components/SynergyCrystalBonusView';
import ItemFilterForm from '../common/items/ItemFilterForm';

class ItemSetContainer extends Component {

    constructor() {
        super();

        this.state = {
            items: [],
            tags: [],
        };
    }

    componentDidMount() {
        this.props.get(this.props.match.params.id);
    }

    componentDidUpdate(prevProps) {
        if(this.props.itemset && !prevProps.itemset) {
            this.setState({
                items: this.props.itemset.Items,
            });
        }
    }

    onFilterChange = (tags) => {

        const {Items} = this.props.itemset;

        const filteredItems = tags === [] ?
            Items :
            compact( Items.map( i => intersection( i.Tags, tags ).length === tags.length ? i : null ) );

        this.setState({
            tags: tags,
            items: filteredItems,
        });
    }

    render() {

        const {itemset, isFetching} = this.props;
        const {items} = this.state;

        if(isFetching || !itemset) {
            return (
                <Container>
                    <Dimmer active page>
                        <Loader>Loading</Loader>
                    </Dimmer>
                </Container>
            )
        }

        const setBonusTable = itemset.Bonuses ? <SetBonusTable bonuses={itemset.Bonuses} /> : null;
        const crystalView = itemset.Crystals.length > 0 ? <SynergyCrystalBonusView crystals={itemset.Crystals} /> : null;

        return (
            <Container>
                <Header as='h2' textAlign='center'>
                    <Header.Content>{itemset.Name.English}</Header.Content>
                    <Header.Subheader>{`${itemset.Pieces} Piece Set`}</Header.Subheader>
                </Header>
                <Grid stackable>
                    <Grid.Row centered>
                        <Grid.Column width={7}>
                            <Segment.Group>
                            <Segment>
                                <Header as="h3">
                                    <Header.Content>Bonuses</Header.Content>
                                </Header>
                            </Segment>
                            <Segment attached="top">
                                {setBonusTable}
                                {crystalView}
                            </Segment>
                            </Segment.Group>
                        </Grid.Column>
                        <Grid.Column width={9}>
                            <Segment.Group>
                                <Segment>
                                    <Header as="h3">
                                        <Header.Content>Items in set</Header.Content>
                                    </Header>
                                </Segment>
                                <Segment attached="top">
                                    <ItemFilterForm onFilterChange={this.onFilterChange} items={itemset.Items} />
                                    <PagedItemView items={items} itemsPerRow={2}/>
                                </Segment>
                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        );
    }
}

const mapStateToProps = state => ({
    itemset: state.itemsetState.itemset,
    isFetching: state.itemsetState.isFetching,
});

const mapDispatchToProps = () => ({
    get,
});

export default connect(mapStateToProps, mapDispatchToProps())(ItemSetContainer);


// WEBPACK FOOTER //
// ./src/itemsets/ItemSetContainer.jsx